/**
 * ODDFISH — Black CTA strike button hover/focus only + AOS
 */
(function () {
  "use strict";

  function initAOS() {
    if (window.oddfishAosInit || typeof AOS === "undefined") return false;
    AOS.init({
      once: true,
      duration: 800,
      easing: "ease-out-cubic",
      offset: 120
    });
    window.oddfishAosInit = true;
    return true;
  }

  function bindStrikeBtn(btn) {
    if (!btn || btn.dataset.oddfishStrikeBound) return;
    btn.dataset.oddfishStrikeBound = "true";

    btn.addEventListener("mouseenter", function () {
      btn.classList.add("strike-visible");
    });

    btn.addEventListener("mouseleave", function () {
      btn.classList.remove("strike-visible");
    });

    btn.addEventListener("focusin", function () {
      btn.classList.add("strike-visible");
    });

    btn.addEventListener("focusout", function () {
      btn.classList.remove("strike-visible");
    });
  }

  function initBlackCta(root) {
    if (!root || root.dataset.oddfishBlackCtaInit) return;
    root.dataset.oddfishBlackCtaInit = "true";

    var isEditor =
      (window.Shopify && window.Shopify.designMode) ||
      document.documentElement.classList.contains("shopify-design-mode") ||
      /[?&]oseid=/.test(window.location.search);

    if (isEditor) {
      root.classList.add("no-aos");
      root.querySelectorAll("[data-aos]").forEach(function (el) {
        el.classList.add("aos-animate");
      });
    }

    if (!initAOS()) {
      setTimeout(function () {
        if (!initAOS()) root.classList.add("no-aos");
      }, 1500);
    }

    var btn = root.querySelector(".strike_btn.strike");
    if (!btn) return;

    bindStrikeBtn(btn);
  }

  function scan() {
    document.querySelectorAll(".oddfish-black-cta").forEach(initBlackCta);
  }

  function boot() {
    scan();
    if (typeof AOS === "undefined") {
      window.addEventListener("load", function () {
        initAOS();
        scan();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    scan();
    if (event.target && !event.target.querySelector(".oddfish-footer-cta") &&
        window.OddfishFooterCta && typeof window.OddfishFooterCta.reinitAll === "function") {
      window.setTimeout(function () {
        window.OddfishFooterCta.reinitAll();
      }, 0);
    }
  });

  document.addEventListener("shopify:section:unload", function () {
    if (window.OddfishFooterCta && typeof window.OddfishFooterCta.reinitAll === "function") {
      window.setTimeout(function () {
        window.OddfishFooterCta.reinitAll();
      }, 0);
    }
  });
})();
